export interface IAutomationLifecycleStats {
  total: number;
  draft: number;
  active: number;
  disabled: number;
}

export interface IAutomationExecutionLifecycleStats {
  total: number;
  pending: number;
  running: number;
  failed: number;
  terminated: number;
  completed: number;
}

export interface IAutomationExecutionPeriodicStats {
  allTime: IAutomationExecutionLifecycleStats;
  today: IAutomationExecutionLifecycleStats;
  yesterday: IAutomationExecutionLifecycleStats;
  pastWeek: IAutomationExecutionLifecycleStats;
}

export interface IAutomationStats {
  executions: IAutomationExecutionPeriodicStats;
  lastExecutionDate?: Date;
}
